import { Link } from 'gatsby';
import React from 'react';
const HowWorks = () => (
  <>
    <section className="siteSection with-bg">
    <div className="detail-process">
      <div className="container">
        <p style={{ textAlign: "center"}} className='detail-process-head mb-3 responsivetxt-lg'>How It Works?</p>

        <div className="steps-line">
          <div className="detail-process-steps">

            <div className="para-text">
              <span className="step-count">1</span>
              <div className="text">
                <p><span>Understanding Your </span><br/>Business Goals</p>
              </div>
              <div className="steps"></div>
            </div>
            <div className="para-text">
              <span className="step-count">2</span>
              <div className="text">
              <p><span>Initiating a </span><br/>Kick-off Meeting</p>

              </div>
              <div className="steps"></div>
            </div>
            <div className="para-text">
              <span className="step-count">3</span>
              <div className="text">
                <p><span>Achieving </span><br />Results </p>

              </div>
              <div className="steps"></div>
            </div>
            <div className="para-text">
              <span className="step-count">4</span>
              <div className="text">
                <p><span>Scaling</span><br /> Fast</p>
              </div>
              <div className="steps"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
   
  </>
);

export default HowWorks;
